import { Button } from '@lmc/ui-kit'
import type { ButtonVariant } from '@lmc/ui-kit/src/general/Button/Button'
import { Dropdown } from 'antd'
import type React from 'react'
import type { ReactElement } from 'react'
import Icon from '../../../general/Icon'

export type DropdownButtonProps = {
  buttonText: string
  overlay: ReactElement
  style?: React.CSSProperties
  type: ButtonVariant
  testId?: string
  disabledByPermission?: boolean
}

export default function DropdownButton({
  buttonText,
  overlay,
  style,
  type,
  testId,
  disabledByPermission
}: DropdownButtonProps): ReactElement {
  const containerStyle = {
    ...styles.container,
    ...style
  }

  return (
    <div style={containerStyle} data-testid={testId}>
      <Dropdown
        disabled={disabledByPermission}
        overlay={overlay}
        trigger={['click']}
      >
        <Button variant={type} disabledByPermission={disabledByPermission}>
          <div style={styles.dropdownBtn}>
            <div>{buttonText}</div>
            <Icon name="DownOutlined" style={styles.dropdownIcon} />
          </div>
        </Button>
      </Dropdown>
    </div>
  )
}

const styles = {
  dropdownBtn: {
    display: 'flex',
    alignItems: 'center'
  },
  dropdownIcon: {
    marginLeft: 8
  },
  container: {
    display: 'flex',
    alignItems: 'center'
  }
}
